import { render, staticRenderFns } from "./ReleasePreview.vue?vue&type=template&id=b4255e88&"
import script from "./ReleasePreview.vue?vue&type=script&lang=js&"
export * from "./ReleasePreview.vue?vue&type=script&lang=js&"
import style0 from "./ReleasePreview.vue?vue&type=style&index=0&id=b4255e88&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports